//Sprint 22 - 7728 - Adicionar na Tela de Equipamentos - Status do Equipamento

import { HttpService } from "./http.service";

const basePath = "/EquipmentStatus";
const request = HttpService.handleRequest();

export const EquipmentStatusService = {
  getAll,
  getById
};


async function getById(id) {
  return request.get(`${basePath}/${id}`);
}

async function getAll() {
  return request.get(basePath);
}

export default EquipmentStatusService;